// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_Menu_Query from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic_Menu_V2_CartToOrder from "../Restaumatic.Menu.V2.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogueQuery from "../Restaumatic.Menu.V2.MenuCatalogueQuery/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var productPrice = function (v) {
    var success = function (price) {
        return {
            price: new Data_Maybe.Just(price),
            errors: Data_Maybe.Nothing.value
        };
    };
    return function (v1) {
        if (v1 instanceof Restaumatic_Cart_ProductKey.CustomProduct) {
            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(success(Data_Record.getField(Restaumatic_Cart_ProductKey.hasFieldCustomProductKey(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "price";
                }
            })()))(Type_Proxy["Proxy"].value)(v1.value0)));
        };
        if (v1 instanceof Restaumatic_Cart_ProductKey.MenuProduct) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.askMenuCatalogue)(function (menu) {
                var v2 = Restaumatic_Menu_V2_CartToOrder.runCartToOrder(Restaumatic_Menu_V2_CartToOrder.cartProductToOrderItems(menu)(v.locale)(v.schedules)(v1.value0)(v.params)(Data_Map_Internal.empty));
                if (v2 instanceof Data_Either.Right) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                        price: new Data_Maybe.Just(v2.value0.value0.unitPrice),
                        errors: new Data_Maybe.Just(new Data_Either.Right(v2.value0.value1))
                    });
                };
                if (v2 instanceof Data_Either.Left) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                        price: Data_Maybe.Nothing.value,
                        errors: new Data_Maybe.Just(new Data_Either.Left(v2.value0))
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 25, column 7 - line 27, column 75): " + [ v2.constructor.name ]);
            });
        };
        if (v1 instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.askMenuCatalogue)(function (menu) {
                var v2 = Restaumatic_Menu_V2_CartToOrder.runCartToOrder(Restaumatic_Menu_V2_CartToOrder.cartComboToOrderItems(menu)(v.locale)(v.schedules)(v1.value0)(v.params));
                if (v2 instanceof Data_Either.Right) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                        price: new Data_Maybe.Just(Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney)(Data_Functor.map(Data_Functor.functorArray)(function (v3) {
                            return v3.unitPrice;
                        })(v2.value0.value0))),
                        errors: new Data_Maybe.Just(new Data_Either.Right(v2.value0.value1))
                    });
                };
                if (v2 instanceof Data_Either.Left) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                        price: Data_Maybe.Nothing.value,
                        errors: new Data_Maybe.Just(new Data_Either.Left(v2.value0))
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 31, column 7 - line 33, column 75): " + [ v2.constructor.name ]);
            });
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.Pricing (line 19, column 3 - line 33, column 75): " + [ v1.constructor.name ]);
    };
};
export {
    productPrice
};
//# sourceMappingURL=index.js.map
